exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  font-weight: 600;\n  margin-top: 20px;\n  font-size: 24px; }\n\n.customBtn {\n  border-radius: 0px;\n  padding: 10px; }\n\n#toast {\n  visibility: hidden;\n  max-width: 250px;\n  height: 50px;\n  /*margin-left: -125px;*/\n  margin: auto;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 2px;\n  position: fixed;\n  z-index: 1;\n  left: 60%;\n  right: 0;\n  bottom: 80%;\n  font-size: 13px;\n  white-space: nowrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/add/otp-screen/otp-screen.component.scss
// module id = ../../../../../src/app/add/otp-screen/otp-screen.component.scss
// module chunks = main